// Picture
// Browser market share and screen resolutions Q1 - Q2 2019 United States
// Chrome: 50.47% Safari: 31.03% IE: 4.97% FF: 4.26% Samsung Int: 2.42%
// 1920x1080  1366x768   375x667  360x640 768x1024  414x736
// 10.24%     8.44%      8.39%    7.29%   5.19%     5.16%

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';

const RespImg = styled.picture`
	position: relative;
	display: block;
	width: 100%;
  img,
  source,
  iframe,
  video {
    width: 100%;
    display: block;
  }
`;
const Img = styled.img`
  .lazyload,
  .lazyloading {
    opacity: 0;
  }
  .lazyloaded {
    opacity: 1;
    transition: opacity 400ms;
  }
`;

function Picture({ className = "", ...props }) {

  const transPixel =
    "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
  const classNames = [ "common-picture lazyload", className ].join(" ");

  return (
    <RespImg>
      <source
        type="image/webp"
        data-sizes="auto"
        data-srcset={ `
        ${ props.srcXs } ${ props.wDesXs }w,
        ${ props.srcSm } ${ props.wDesSm }w,
        ${ props.srcMd } ${ props.wDesMd }w,
        ${ props.srcLg } ${ props.wDesLg }w,
        ${ props.srcXl } ${ props.wDesXl }w
      ` }
        data-aspectratio={ props.aspectratio }
      />
      <Img
        type={ `image/${ props.imgType }` }
        data-sizes="auto"
        data-srcset={ `
          ${ props.imgXs } ${ props.wDesXs }w,
          ${ props.imgSm } ${ props.wDesSm }w,
          ${ props.imgMd } ${ props.wDesMd }w,
          ${ props.imgLg } ${ props.wDesLg }w,
          ${ props.imgXl } ${ props.wDesXl }w
        ` }
        data-aspectratio={ props.aspectratio }
        className={ classNames }
        data-src={ props.imgXl }
        src={ transPixel }
        alt={ props.alt }
      />
    </RespImg>
  );
}

Picture.propTypes = {
  imgType: PropTypes.string,
  alt: PropTypes.string,
  // image sizes
  wDesXs: PropTypes.number,
  wDesSm: PropTypes.number,
  wDesMd: PropTypes.number,
  wDesLg: PropTypes.number,
  wDesXl: PropTypes.number,
  // images size ratio
  aspectratio: PropTypes.number,
  // source url
  srcXs: PropTypes.string,
  srcSm: PropTypes.string,
  srcMd: PropTypes.string,
  srcLg: PropTypes.string,
  srcXl: PropTypes.string,
  // image url
  imgXs: PropTypes.string,
  imgSm: PropTypes.string,
  imgMd: PropTypes.string,
  imgLg: PropTypes.string,
  imgXl: PropTypes.string,

  // ClassNames
  className: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
};

export default Picture;




// WEBPACK FOOTER //
// ./src/features/common/Picture.js